// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__361eN","title":"ClientInsurance_title__3ZTSb","itemText":"ClientInsurance_itemText__H4euP"};